import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { config } from 'app/shared/smartadmin.config';

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  currentPark = config.currentPark;
  searchMobileActive = false;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }



  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts